import { filter, find, get, head, isEmpty, last } from 'lodash';
import { Promise } from 'es6-promise';
import { IAuthState } from '../services/auth/models';
import { IQuoteActions } from '../services/quote/models';
import { IModalActions, IUpsellCampaign } from '../services/modal/model';
import { IMtaActions } from '../services/mta/models';

export const initUpsellModal = (auth: IAuthState, actionsQuote: IQuoteActions, actionsModal: IModalActions, actionsMta: IMtaActions, upsellCampaign: IUpsellCampaign = null) => {
  const showModal = sessionStorage.getItem('showMarketingUpsell')

  if (showModal === 'hide') {
    return;
  }

  const activePolicies = get(auth, 'customer.activePolicies');
  const singleTripPolicies = filter(activePolicies, ['metadata.scheme_type', 'single']);

  if ((singleTripPolicies && singleTripPolicies.length >= 2)) {
    return null;
  }

  const policy = head(singleTripPolicies);

  const campaign = get(policy, 'metadata.campaign', null)
  const campaignCode = get(policy, 'metadata.campaign_code', null)
  const hasDiscount = campaign !== null && campaignCode !== null;

  if (!policy) {
    return null;
  }

  const upsellDisabled = policy.campaigns?.some(campaign => campaign.metadata?.prevent_mta_upsell)
  if (upsellDisabled) {
    return null;
  }

  const policyCoverLevel = get(last(get(policy, 'premiums')), 'scheme.coverLevel', '');
  const IPIDLink = find(get(policy, 'documents', []), ['name', 'Insurance Product Information Document']);

  const data = {
    data: {
      attributes: policy
    }
  }

  Promise.resolve(actionsQuote.calculateUpsellQuote(data)).then((response) => {
    const premium = find(response, {
      'scheme': {
        'cover_level': policyCoverLevel,
        'scheme_type': 'Annual Multi Trip'
      }
    })
    if (
      premium &&
      isEmpty(premium.declines) &&
      isEmpty(premium.errors) &&
      isEmpty(premium.referrals) &&
      premium?.premium?.gross > 0 &&
      premium?.mta?.old_premium?.gross > 0
    ) {
      const calculatedPremium = parseFloat(get(premium, 'premium.gross'));
      const fullAmtPremium = parseFloat(get(premium, 'mta.new_premium.gross'));

      const data = {
        IPIDLink,
        difference: calculatedPremium,
        fullAMTPrice: fullAmtPremium,
        policyId: policy.id,
        campaign: upsellCampaign,
        hasDiscount,
      }

      actionsModal.openUpsellModal(data)
      actionsMta.setUpsellData([data])
    }
  });
}
